<template>
  <div class="popover-item" v-bind="$attrs" v-on="$listeners">
    <slot v-if="$slots.icon" name="icon" />

    <slot v-if="$slots.label" name="label" />
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.action-icon {
  margin: 0 rem(12px) 0 0;
}

.popover-item {
  padding: rem(10px) rem(16px);
  font-size: rem(12px);
  color: $color-gray-600;
  cursor: pointer;

  @include unselectable();
  @include createFlex(flexbox, nowrap, row, flex-start, center, center);

  &:hover {
    cursor: pointer;
    background: $color-gray-25;
  }
}
</style>
